import React from 'react';

import { flagStyles } from '../settings';

const SvgHN = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2280px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgHN;
